import http from '../utils/request'



//防伪码查询
export const barcode = (data) => {
  return http.post('wx/api/code/barcode',data)
}

